/* import __COLOCATED_TEMPLATE__ from './workspace.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import AdminSummary from 'embercom/objects/inbox/admin-summary';

export default class WorkspaceLoader extends Component<{
  Blocks: {
    default: [];
  };
}> {
  @service declare appService: any;
  @service session!: Session;

  constructor(owner: unknown, args: {}) {
    super(owner, args);
    this.session.switchWorkspace(this.appService.app.id);

    this.session.workspace.isStandaloneApp = this.appService.app.isStandaloneApp;

    // @ts-ignore
    if (!this.session._teammate) {
      let admin = this.appService.app.currentAdmin;

      // @ts-ignore
      this.session._teammate = new AdminSummary(
        admin.id,
        admin.name,
        admin.avatarUrl,
        admin.alias_enabled,
        admin.alias_name,
        admin.alias_email,
      );
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Adapters::Workspace': typeof WorkspaceLoader;
    'inbox2/adapters/workspace': typeof WorkspaceLoader;
  }
}
